import { DocumentsRequired } from 'modules/case-tracking/types/documents-required/documents-required.types';
import {
  ClientMaintenanceInstruction,
  NewBusinessInstruction,
  PolicyMaintenanceInstruction,
  Stage
} from 'modules/case-tracking/types/case-tracking.enums';
import { InstructionCategory, Status } from 'modules/case-tracking/types/filtering/filtering.enums';
import { CaseType } from 'modules/case-tracking/types/case-tracking.types';

export const mockDocumentsRequested: DocumentsRequired[] = [
  {
    instructionId: '1008',
    documentName: 'Original certified Copy of proof of Residential Address',
    requestDate: new Date()
  },
  {
    instructionId: '1008',
    documentName: 'FATCA - IRS - W9 form',
    requestDate: new Date('2025-08-02')
  },
  {
    instructionId: '1009',
    documentName: 'Certificate of Name Change (CM9/CoR 14.3)',
    requestDate: new Date('2025-07-29')
  },
  {
    instructionId: '1010',
    documentName: 'Original certified Copy of proof of Residential Address',
    requestDate: new Date()
  },
  {
    instructionId: '1010',
    documentName: 'FATCA - IRS - W9 form',
    requestDate: new Date('2025-08-02')
  },
  {
    instructionId: '1011',
    documentName: 'Certificate of Name Change (CM9/CoR 14.3)',
    requestDate: new Date('2025-07-29')
  },
  {
    instructionId: '1006',
    documentName: 'Original certified Copy of proof of Residential Address',
    requestDate: new Date()
  },
  {
    instructionId: '1006',
    documentName: 'FATCA - IRS - W9 form',
    requestDate: new Date('2025-08-02')
  },
  {
    instructionId: '1006',
    documentName: 'Certificate of Name Change (CM9/CoR 14.3)',
    requestDate: new Date('2025-07-29')
  }
];

export const mockCaseData: CaseType[] = [
  {
    id: 1,
    created: new Date('2025-01-02'),
    instructionNumber: 1000,
    clientName: 'Alice Brown',
    clientId: 19871029,
    instructionType: NewBusinessInstruction.endowment,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 34,
    investmentNumber: 12764538,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-02-02')
  },
  {
    id: 2,
    created: new Date('2025-05-02'),
    instructionNumber: 1002,
    clientName: 'Jon Doe',
    clientId: 21398612,
    instructionType: PolicyMaintenanceInstruction.incomeChanges,
    instructionCategory: InstructionCategory.PlanMaintenance,
    proposalNumber: 2139860,
    investmentNumber: 8762597,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-05-02')
  },
  {
    id: 3,
    created: new Date('2025-01-02'),
    instructionNumber: 1003,
    clientName: 'Alice Smith Bakery',
    clientId: 12087429,
    instructionType: PolicyMaintenanceInstruction.phasingIn,
    instructionCategory: InstructionCategory.PlanMaintenance,
    proposalNumber: 1243140,
    investmentNumber: 27645389,
    stage: 3,
    stageDescription: Stage.Stage3,
    status: Status.processingApplication,
    isCancelled: false,
    lastModified: new Date('2025-07-21')
  },
  {
    id: 4,
    created: new Date('2025-06-18'),
    instructionNumber: 1004,
    clientName: 'Bruce Wayne',
    clientId: 10000000,
    instructionType: PolicyMaintenanceInstruction.policyRoles,
    instructionCategory: InstructionCategory.PlanMaintenance,
    proposalNumber: 124130,
    investmentNumber: 8752934,
    stage: 2,
    stageDescription: Stage.Cancelled,
    status: Status.instructionCancelled,
    isCancelled: true,
    lastModified: new Date('2025-06-20'),
    cancellationReason: ''
  },
  {
    id: 5,
    created: new Date('2025-08-12'),
    instructionNumber: 1005,
    clientName: 'Molly Mae',
    clientId: 10000001,
    instructionType: NewBusinessInstruction.tfsaAdhoc,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 12430,
    investmentNumber: 876532986,
    stage: 4,
    stageDescription: Stage.Stage4,
    status: Status.instructionFinalised,
    isCancelled: false,
    lastModified: new Date('2025-09-20'),
    activityHistory: [
      {
        stage: 4,
        stageName: Stage.Stage4,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '5-9',
            statusName: Status.instructionFinalised,
            timestamp: '10:11',
            date: new Date('2024-06-24'),
            stage: 4,
            isCompleted: false,
            isCancelled: false
          },
          {
            id: '5-8',
            statusName: Status.purchasingUnits,
            timestamp: '11:30',
            date: new Date('2024-06-24'),
            stage: 4,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 3,
        stageName: Stage.Stage3,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '5-7',
            statusName: 'Funds being allocated',
            timestamp: '13:10',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false,
            isInProgress: false
          },
          {
            id: '5-6',
            statusName: Status.pendingContribution,
            timestamp: '12:32',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '5-5',
            statusName: Status.bankDetailSent,
            timestamp: '11:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '5-4',
            statusName: Status.processingApplication,
            timestamp: '11:20',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 2,
        stageName: Stage.Stage2,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '5-3',
            statusName: Status.requirementValidation,
            timestamp: '15:30',
            date: new Date('2024-03-23'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '5-2',
            statusName: Status.requirementRequested,
            timestamp: '14:30',
            date: new Date('2024-03-22'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '5-1',
            statusName: Status.requirementVerification,
            timestamp: '14:15',
            date: new Date('2024-03-20'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 1,
        stageName: Stage.Stage1,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '5-0',
            statusName: Status.instructionReceived,
            timestamp: '08:45',
            date: new Date('2024-06-18'),
            stage: 1,
            isCompleted: true,
            isCancelled: false
          }
        ]
      }
    ]
  },
  {
    id: 6,
    created: new Date('2025-03-15'),
    instructionNumber: 1006,
    clientName: 'Clark Kent',
    clientId: 10000002,
    instructionType: ClientMaintenanceInstruction.bankDetailsChange,
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 45,
    investmentNumber: 86753986,
    stage: 2,
    stageDescription: Stage.Cancelled,
    status: Status.policyCancelled,
    isCancelled: true,
    lastModified: new Date('2025-04-01'),
    cancellationReason: 'Plan cancelled by client'
  },
  {
    id: 7,
    created: new Date('2025-02-10'),
    instructionNumber: 1007,
    clientName: 'Lois Lane',
    clientId: 10000003,
    instructionType: NewBusinessInstruction.raUnitTransferAdhoc,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 523422,
    investmentNumber: 3246673,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-02-15')
  },
  {
    id: 8,
    created: new Date('2025-06-01'),
    instructionNumber: 1008,
    clientName: 'Tony Stark',
    clientId: 10000004,
    instructionType: NewBusinessInstruction.sinkingFund,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 23411,
    investmentNumber: 234566,
    stage: 3,
    stageDescription: Stage.Stage3,
    status: Status.processingApplication,
    isCancelled: false,
    lastModified: new Date('2025-06-10'),
    activityHistory: [
      {
        stage: 3,
        stageName: Stage.Stage3,
        isCompleted: false,
        isCancelled: false,
        isInProgress: true,
        activities: [
          {
            id: '17-7',
            statusName: 'Funds being allocated',
            timestamp: '13:10',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: false,
            isCancelled: false,
            isInProgress: true
          },
          {
            id: '17-6',
            statusName: Status.pendingContribution,
            timestamp: '12:32',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-5',
            statusName: Status.bankDetailSent,
            timestamp: '11:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-4',
            statusName: 'Instruction verified',
            timestamp: '10:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 2,
        stageName: Stage.Stage2,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '17-3',
            statusName: Status.requirementValidation,
            timestamp: '15:30',
            date: new Date('2024-03-23'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-2',
            statusName: Status.requirementRequested,
            timestamp: '14:30',
            date: new Date('2024-03-22'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-1',
            statusName: Status.requirementVerification,
            timestamp: '14:15',
            date: new Date('2024-03-20'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 1,
        stageName: Stage.Stage1,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '17-0',
            statusName: Status.instructionReceived,
            timestamp: '08:45',
            date: new Date('2024-06-18'),
            stage: 1,
            isCompleted: true,
            isCancelled: false
          }
        ]
      }
    ]
  },
  {
    id: 9,
    created: new Date('2025-07-22'),
    instructionNumber: 1009,
    clientName: 'Steve Rogers',
    clientId: 10000005,
    instructionType: ClientMaintenanceInstruction.secureServicesRegister,
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 2352377,
    investmentNumber: 3265438,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-07-30')
  },
  {
    id: 10,
    created: new Date('2025-04-11'),
    instructionNumber: 1010,
    clientName: 'Peter Parker',
    clientId: 10000006,
    instructionType: NewBusinessInstruction.endowmentContinuation,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 32412,
    investmentNumber: 3765484,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-04-12')
  },
  {
    id: 11,
    created: new Date('2025-01-05'),
    instructionNumber: 1011,
    clientName: 'Wanda Maximoff',
    clientId: 10000007,
    instructionType: PolicyMaintenanceInstruction.feesAndCharges,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 23550,
    investmentNumber: 1342435,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-01-07')
  },
  {
    id: 12,
    created: new Date('2025-02-18'),
    instructionNumber: 1012,
    clientName: 'Bruce Banner',
    clientId: 10000008,
    instructionType: NewBusinessInstruction.tfsaUnitTransfer,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 235230,
    investmentNumber: 23523423,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-02-20')
  },
  {
    id: 13,
    created: new Date('2025-08-01'),
    instructionNumber: 1013,
    clientName: 'Natashâ Romanoff',
    clientId: 10000009,
    instructionType: ClientMaintenanceInstruction.enquiries,
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 56,
    investmentNumber: 23532423,
    stage: 4,
    stageDescription: Stage.Stage4,
    status: Status.purchasingUnits,
    isCancelled: false,
    lastModified: new Date('2025-08-05')
  },
  {
    id: 14,
    created: new Date('2025-03-25'),
    instructionNumber: 1014,
    clientName: 'Scott Lang',
    clientId: 10000010,
    instructionType: NewBusinessInstruction.preservationPensionFund,
    instructionCategory: InstructionCategory.NewBusiness,
    proposalNumber: 33,
    investmentNumber: 3254234,
    stage: 2,
    stageDescription: Stage.Stage2,
    status: Status.requirementVerification,
    isCancelled: false,
    lastModified: new Date('2025-03-30')
  },
  {
    id: 15,
    created: new Date('2025-04-01'),
    instructionNumber: 1015,
    clientName: 'Stephen Strange',
    clientId: 10000011,
    instructionType: ClientMaintenanceInstruction.taxMaintenance,
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 29,
    investmentNumber: 235234,
    stage: 1,
    stageDescription: Stage.Stage1,
    status: Status.instructionReceived,
    isCancelled: false,
    lastModified: new Date('2025-04-05')
  },
  {
    id: 16,
    created: new Date('2025-04-02'),
    instructionNumber: 1089,
    clientName: 'Peter Barker',
    clientId: 1032341,
    instructionType: 'Policy upgrade',
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 229,
    investmentNumber: undefined,
    stage: 2,
    stageDescription: Stage.Stage2,
    status: Status.requirementValidation,
    isCancelled: false,
    lastModified: new Date('2025-04-05'),
    activityHistory: [
      {
        stage: 2,
        stageName: Stage.Stage2,
        isCompleted: false,
        isCancelled: false,
        isInProgress: true,
        activities: [
          {
            id: '16-1',
            statusName: Status.requirementVerification,
            timestamp: '14:15',
            date: new Date('2024-03-20'),
            stage: 2,
            isCompleted: false,
            isCancelled: false,
            isInProgress: true
          }
        ]
      },
      {
        stage: 3,
        stageName: Stage.Stage3,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '16-5',
            statusName: Status.bankDetailSent,
            timestamp: '11:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '16-4',
            statusName: 'Instruction verified',
            timestamp: '10:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 2,
        stageName: Stage.Stage2,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '16-3',
            statusName: Status.requirementValidation,
            timestamp: '15:30',
            date: new Date('2024-03-23'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '16-2',
            statusName: Status.requirementRequested,
            timestamp: '14:30',
            date: new Date('2024-03-22'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '16-1',
            statusName: Status.requirementVerification,
            timestamp: '14:15',
            date: new Date('2024-03-20'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 1,
        stageName: Stage.Stage1,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '16-0',
            statusName: Status.instructionReceived,
            timestamp: '08:45',
            date: new Date('2024-06-18'),
            stage: 1,
            isCompleted: true,
            isCancelled: false
          }
        ]
      }
    ]
  },
  {
    id: 17,
    created: new Date('2025-09-11'),
    instructionNumber: 1090,
    clientName: 'Bob Builder',
    clientId: 10021002,
    instructionType: 'Plan reinstatement',
    instructionCategory: InstructionCategory.ClientMaintenance,
    proposalNumber: 451,
    investmentNumber: 8142986,
    stage: 3,
    stageDescription: Stage.Cancelled,
    status: Status.policyCancelled,
    isCancelled: true,
    lastModified: new Date('2025-04-01'),
    cancellationReason: 'Instruction cancelled by intermediary',
    //Todo - check if extra status' from design are needed
    activityHistory: [
      {
        stage: 3,
        stageName: Stage.Stage3,
        isCompleted: false,
        isCancelled: true,
        isInProgress: false,
        activities: [
          {
            id: '17-8',
            statusName: Status.instructionCancelled,
            timestamp: '14:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: false,
            isCancelled: true,
            isInProgress: false,
            cancellationReason: 'Instruction cancelled by intermediary'
          },
          {
            id: '17-7',
            statusName: 'Funds being allocated',
            timestamp: '13:10',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: false,
            isCancelled: false,
            isInProgress: true
          },
          {
            id: '17-6',
            statusName: Status.pendingContribution,
            timestamp: '12:32',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-5',
            statusName: Status.bankDetailSent,
            timestamp: '11:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-4',
            statusName: 'Instruction verified',
            timestamp: '10:30',
            date: new Date('2024-06-24'),
            stage: 3,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 2,
        stageName: Stage.Stage2,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '17-3',
            statusName: Status.requirementValidation,
            timestamp: '15:30',
            date: new Date('2024-03-23'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-2',
            statusName: Status.requirementRequested,
            timestamp: '14:30',
            date: new Date('2024-03-22'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          },
          {
            id: '17-1',
            statusName: Status.requirementVerification,
            timestamp: '14:15',
            date: new Date('2024-03-20'),
            stage: 2,
            isCompleted: true,
            isCancelled: false
          }
        ]
      },
      {
        stage: 1,
        stageName: Stage.Stage1,
        isCompleted: true,
        isCancelled: false,
        isInProgress: false,
        activities: [
          {
            id: '17-0',
            statusName: Status.instructionReceived,
            timestamp: '08:45',
            date: new Date('2024-06-18'),
            stage: 1,
            isCompleted: true,
            isCancelled: false
          }
        ]
      }
    ]
  }
];
